//index.js
import "./HomePage.scss";
import React, { useState, useEffect } from "react";
import data from "../../data/dealerPackages.json";
import Header from "../../components/ui/StickyHeader";
import Footer from "./Footer";
import Button from "../../components/ui/Button";
import TextBlock from "../../components/ui/TextBlock";
import LogoCard from "../../components/ui/LogoCard";
import Tile from "./PackageCard.js";
import mobileHeaderImage from "../../assets/Mobile_header.png";

const Home = () => {
	//for DealerPackagesSelector
	const [selectedCategory] = useState("No Package Selector");
	const [dataState, setDataState] = useState([]);

	useEffect(() => {
		if (data && data.packages && data.packages[selectedCategory]) {
			setDataState(data.packages[selectedCategory]);
		}
	}, [selectedCategory]);

	return (
		<>
			<Header />

			{/* ------------ hero ------------ */}
			<div className="hero-container-wrapper">
				<div
					className="hero-container"
					style={{
						"--mobile-header-bg": `url(${mobileHeaderImage})`,
					}}>
					<TextBlock
						hat="2026 BMW EASTERN REGION TIER 3 BLITZ PROGRAMS"
						title={
							<>
								0% Agency Fees.
								<br />
								Built for Performance.
							</>
						}
						paragraph="Media packages designed to drive inventory visibility, VDP engagement, and qualified leads."
						type="h1"
						color="white"
						align="center"
					/>
					<div className="button-container">
						<Button link="/enroll" styleName="blue" size="large">
							Enroll Now
						</Button>
						{/* <a
							href={strategyDeckPDF}
							className="global_button white_button small_button"
							target="_blank"
							rel="noopener noreferrer">
							Explore the Strategy
						</a> */}
					</div>
				</div>
			</div>
			<div className="home-container">
				{/* ------------ media packages ------------ */}
				<div
					className="dealer-packages-container"
					id="dealer-packages-anchor">
					<TextBlock
						title="Media Packages"
						type="sectionHeader"
						align="center"
					/>

					<div className="columns-container">
						{Array.isArray(dataState) && dataState.length > 0 ? (
							dataState.map((plan, index) => (
								<div className="column" key={index}>
									<Tile
										size="large"
										title={plan.title}
										description={plan.description}
										cost={plan.cost}
										pill={plan.pill}
										disclaimer={plan.disclaimer}
										listSpecs={plan.listSpecs}
										logos={plan.logos}
										cta={plan.cta}
									/>
								</div>
							))
						) : (
							<div>
								No data available for the selected category.
							</div>
						)}
					</div>
					<p className="disclaimer" style={{ textAlign: "center" }}>
						<span style={{ fontWeight: "bold" }}>
							*Enrollment Deadline February 28th
						</span>
					</p>
				</div>

				{/* ------------ program overview ------------ */}
				<div className="program-overview-container">
					<TextBlock
						title="Bring in-market shoppers to your website with the BMW Eastern Region Digital Program"
						type="sectionHeader"
						color="black"
						align="center"
					/>

					<div className="columns-container">
						<div className="column">
							<TextBlock
								title="Low-Funnel Traffic"
								paragraph="Bring high-intent shoppers directly to your showroom with a strategy built for conversion."
								type="spec"
								color="black"
								align="left"
							/>
							<TextBlock
								title="Qualified Leads"
								paragraph="Capture and convert active shoppers through precision-targeted lead-gen platforms."
								type="spec"
								color="black"
								align="left"
							/>
						</div>

						<div className="column image-column">
							<video
								src={require("../../assets/theixPhone2.mp4")}
								className="vertical-image"
								autoPlay
								loop
								muted
								playsInline
							/>
						</div>

						<div className="column">
							<TextBlock
								title="Maximum Efficiency"
								paragraph="100% of your budget goes to working media. BMW covers all agency fees to ensure your investment works harder."
								type="spec"
								color="black"
								align="left"
							/>
							<TextBlock
								title="Increased VDP Views"
								paragraph="Drive qualified traffic to specific New Vehicle Detail Pages to move aged and core inventory."
								type="spec"
								color="black"
								align="left"
							/>
						</div>
					</div>
				</div>

				{/* ------------ program packages ------------ */}
				<div className="program-packages-container">
					{/* ------------ program packages > how the program works ------------ */}
					<div className="how-program-works-top-container">
						<div className="columns-container ">
							<div className="column">
								<TextBlock
									title="How the Program Works"
									paragraph="Maximize Inventory Visibility with Dynamic Precision."
									type="sectionHeader"
									color="black"
									align="left"
								/>
							</div>
							<div className="column">
								<TextBlock
									paragraph="Drive high-intent traffic directly to your Vehicle Detail Pages by strategically positioning your current inventory and local dealership. "
									type="p-block"
									color="black"
									fontSize="22"
									fontWeight="300"
								/>
							</div>
						</div>
						<img
							src={require("../../assets/howProgramWorks.png")}
							alt="BMW Car"
							className="small-featured-image"
						/>
					</div>

					<div className="how-program-works-tile-container">
						<div className="columns-container">
							<div className="column">
								<LogoCard
									styleName="vertical"
									size="small"
									alignment="left"
									backgroundImage={require("../../assets/programImgs/adv.png")}
									title="Advanced Creative"
									description="Leverage advanced ad formats that tell a story through stunning designs targeted to in-market shoppers."
								/>
							</div>

							<div className="column">
								<LogoCard
									styleName="vertical"
									size="small"
									alignment="left"
									backgroundImage={require("../../assets/programImgs/dyn.png")}
									title="Dynamic Inventory"
									description="Dynamic Inventory Campaigns drive results by showcasing personalized, real-time vehicle listings to in-market shoppers, maximizing relevance, and boosting website visits."
								/>
							</div>
							<div className="column">
								<LogoCard
									styleName="vertical"
									size="small"
									alignment="left"
									backgroundImage={require("../../assets/programImgs/cont.png")}
									title="Continuous Optimization"
									description="Campaigns are managed daily to maximize efficiency and stay ahead of market shifts."
								/>
							</div>
							<div className="column">
								<LogoCard
									styleName="vertical"
									size="small"
									alignment="left"
									backgroundImage={require("../../assets/programImgs/trans.png")}
									title="Transparent Reporting"
									description="Access live dashboards that align performance data directly with your dealership KPIs."
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div>
				<Footer />
			</div>
		</>
	);
};

export default Home;
